import React, { Fragment, useState } from 'react'
import { Dialog } from '@material-ui/core'
import { StyledEditIcon, StyledParagraph } from './styles'
import EditLocationAddressModal from './EditLocationAddressModal'
import { patchLocation } from '../../../services/postingsLocationsService'

const LocationNameCell = (props) => {
  const { location } = props

  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleClose = () => setOpen(false)

  const handleSave = async (addressDto) => {
    setLoading(true)

    try {
      const addresses = [{ ...addressDto }]
      const locationAddressDto = {
        id: location._id,
        addresses
      }

      await patchLocation(location._id, [locationAddressDto])
      setLoading(false)
      setOpen(false)
      props.refreshPostingsLocations()
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  return (
    <Fragment>
      <StyledParagraph>
        {location.displayName}
      </StyledParagraph>
      <StyledEditIcon onClick={handleOpen} data-testid="edit-location-button" />
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        disableBackdropClick
      >
        <EditLocationAddressModal
          data-testid="edit-location-modal"
          unsetHeight
          location={location}
          loading={loading}
          handleSave={handleSave}
          handleClose={handleClose}
        />
      </Dialog>
    </Fragment>
  )
}

export default LocationNameCell
